import { LANG } from '@/utils'
import type { TypeLang, TypeJsonLd, TypeJsonLdHomepageData, TypeJsonLdAboutUsOriginsData, TypeJsonLdContactPageData, TypeJsonLdBrandsData, TypeJsonLdSearchData, TypeJsonLdProductData } from '@/schema'
import { jsonLdHomepage } from './jsonld/homepage'
import { jsonLdAboutUsOrigins } from './jsonld/aboutUsOrigins'
import { jsonLdContactPage } from './jsonld/contactPage'
import { jsonLdSearchPage } from './jsonld/searchPage'
import { jsonLdBrands } from './jsonld/brands'
import { jsonLdProduct } from './jsonld/product'

const jsonLdByType: Record<TypeJsonLd, (data: unknown, locale: TypeLang) => string> = {
  'homepage': (data, locale) => jsonLdHomepage(data as TypeJsonLdHomepageData, locale),
  'aboutUsOrigins': (data, locale) => jsonLdAboutUsOrigins(data as TypeJsonLdAboutUsOriginsData, locale),
  'contactPage': (data, locale) => jsonLdContactPage(data as TypeJsonLdContactPageData, locale),
  'searchPage': (data, locale) => jsonLdSearchPage(data as TypeJsonLdSearchData | null, locale),
  'brands': (data, locale) => jsonLdBrands(data as TypeJsonLdBrandsData, locale),
  'product': (data, locale) => jsonLdProduct(data as TypeJsonLdProductData, locale),
}

type TypeGetJsonld = {
  type: TypeJsonLd
  data?: unknown
  locale?: TypeLang
}

export const getJsonld = ({ type, data = null, locale = LANG as TypeLang }: TypeGetJsonld) => jsonLdByType[type](data, locale)
